import { ExecutableAction, ExecutableActionParam } from '../utils/executable-action';
import { CurrentRecordModel } from './current-record.state';

export class RecordIsDirty implements ExecutableAction<CurrentRecordModel> {
  static readonly type = '[Current Record] Record Is Dirty';

  execute(params: ExecutableActionParam<CurrentRecordModel>) {
    const state = params.ctx.getState();
    if (!state.dirty) {
      params.ctx.setState({ ...state, dirty: true });
    }
  }
}
